import { SentryEnvironment } from './constants';
/**
 * Creates an exception handler to handle sentry errors.
 * @param {CreateSentryExceptionHandlerOptions} options - The details needed to create
 * the exception handler
 */
export const createSentryExceptionHandler = ({ sentryEnv, client, }) => {
    const captureException = (err) => {
        if (sentryEnv === SentryEnvironment.DEVELOPMENT) {
            return;
        }
        const error = err instanceof Error ? err : new Error(String(err));
        client.captureException(error);
    };
    return captureException;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VudHJ5L3V0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQVloRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sNEJBQTRCLEdBQUcsQ0FBQyxFQUMzQyxTQUFTLEVBQ1QsTUFBTSxHQUM4QixFQUFvQixFQUFFO0lBQzFELE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxHQUFvQixFQUFFLEVBQUU7UUFDaEQsSUFBSSxTQUFTLEtBQUssaUJBQWlCLENBQUMsV0FBVyxFQUFFO1lBQy9DLE9BQU87U0FDUjtRQUVELE1BQU0sS0FBSyxHQUFHLEdBQUcsWUFBWSxLQUFLLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7UUFFbEUsTUFBTSxDQUFDLGdCQUFnQixDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2pDLENBQUMsQ0FBQztJQUVGLE9BQU8sZ0JBQWdCLENBQUM7QUFDMUIsQ0FBQyxDQUFDIn0=